import { useAuth } from 'context/AuthContext';
import NewDashboard from './dashboard';
import { Page, Text } from '@shopify/polaris';

export default function Dashboard() {
  const { currentUserCan } = useAuth();

  return currentUserCan('view_dashboard') ? (
    <NewDashboard />
  ) : (
    <Page>
      <Text as="p">Ngày mới an lành!</Text>
    </Page>
  );
}

